import { PB_DISPLAY_URL } from "@/lib/pb";
// By path, not through `@/ui` — see the note in `AuthGate`.
import { Button } from "@/ui/Button";
import { StatusPanel } from "@/ui/StatusPanel";

export type ServerUnreachableProps = {
  detail?: string | null;
  onRetry: () => void;
  retrying?: boolean;
};

/**
 * Shown whenever Kobo cannot talk to its backend at all.
 *
 * This screen exists so an outage is never mistaken for "nothing to do today".
 * It names the server it tried, so the user can tell a dead VPS apart from a
 * misconfigured build.
 */
export function ServerUnreachable({ detail, onRetry, retrying = false }: ServerUnreachableProps) {
  return (
    <StatusPanel
      fill
      tone="offline"
      icon={<span aria-hidden>⦿</span>}
      title="Cannot reach the Kobo server"
      description={
        <>
          Kobo stores everything on the server, so nothing can be shown until it answers.
          <br />
          <span className="mt-pad-tight inline-block text-caption text-subtle">
            Tried <span className="numeric">{PB_DISPLAY_URL}</span>
            {detail ? ` — ${detail}` : null}
          </span>
        </>
      }
      actions={
        <Button variant="primary" onClick={onRetry} loading={retrying}>
          Try again
        </Button>
      }
    />
  );
}
